import { ClipboardList, Eye, Menu, RotateCcw } from 'lucide-react';
import { getPublicMenuPath } from '@/lib/tenant/getPublicMenuPath';
import {
  DEMO_ASSISTANT_HINTS,
  DEMO_ASSISTANT_INTRO,
  isDemoBusinessId,
} from '@/lib/demo/demoBusiness';
import { formatLastOrderShortLabel } from '@/lib/assistant/assistantRepeatOrder';

/** Botón "Ver carta" — mostaza fija (marca asistente). */
export const ASSISTANT_CATALOG_BUTTON_COLOR = '#D4A017';
export const ASSISTANT_CATALOG_BUTTON_TEXT = '#111111';

/**
 * Texto y opciones del saludo inicial del asistente.
 */
export function buildAssistantWelcomeMessage({
  businessId,
  firstName,
  clubLine = '',
  dailyPromoLine = '',
  orderToRepeat = null,
  navigate,
  routeBid,
  onKnowWhatToOrder,
  onBrowseMenu,
  onStartRepeat,
}) {
  const demoIntro = isDemoBusinessId(businessId) ? DEMO_ASSISTANT_INTRO : '';
  const demoHints = isDemoBusinessId(businessId) ? DEMO_ASSISTANT_HINTS : '';
  const greeting = firstName ? `Hola ${firstName} 👋` : 'Hola 👋';
  const intro = isDemoBusinessId(businessId)
    ? '¿Qué te gustaría pedir?'
    : 'Elegí cómo querés pedir hoy.';

  const hasRepeat = Boolean(orderToRepeat?.items?.length);
  const repeatHint = hasRepeat ? '\n\n📦 Tenés un pedido anterior guardado.' : '';

  const welcomeText = `${demoIntro}${demoHints}${greeting}\n\n${intro}${clubLine}${dailyPromoLine}${repeatHint}`;

  const options = [];

  if (hasRepeat) {
    options.push({
      label: formatLastOrderShortLabel(orderToRepeat),
      value: 'repeat-last',
      icon: RotateCcw,
      variant: 'emphasis',
      action: () => onStartRepeat?.(orderToRepeat),
    });
  }

  options.push({
    label: 'Ver menú tradicional',
    value: 'catalog',
    icon: Eye,
    variant: 'mustard',
    action: () => {
      if (typeof navigate === 'function') {
        navigate(getPublicMenuPath(routeBid, 'catalog'));
      }
    },
  });

  options.push({
    label: 'Sé qué pedir',
    value: 'know-order',
    icon: ClipboardList,
    action: () => onKnowWhatToOrder?.(),
  });

  options.push({
    label: 'No sé qué pedir',
    value: 'browse-menu',
    icon: Menu,
    variant: 'emphasis',
    action: () => onBrowseMenu?.(),
  });

  return { welcomeText, welcomeOptions: options };
}
